import { ElementTypes } from '../enums/ElementTypes';
import { ShapeSeatTypes } from '../enums/ShapeSeatTypes';
import { ISeat } from '../interfaces/ISeat';
import { IShape } from '../interfaces/IShape';

export class ShapeSeatTypeUtils {

  public static resolve(shapeSeatType: ShapeSeatTypes | string | undefined | null): ShapeSeatTypes | undefined {
    if (shapeSeatType == null || shapeSeatType === '') {
      return undefined;
    }

    if ((Object.values(ShapeSeatTypes) as string[]).includes(shapeSeatType as string)) {
      return shapeSeatType as ShapeSeatTypes;
    }

    return (ShapeSeatTypes as Record<string, ShapeSeatTypes>)[shapeSeatType as string];
  }

  public static resolveElementType(shapeElementTypeKey: ElementTypes | string | undefined | null): ElementTypes | undefined {
    if (shapeElementTypeKey == null || shapeElementTypeKey === '') {
      return undefined;
    }

    if ((Object.values(ElementTypes) as string[]).includes(shapeElementTypeKey as string)) {
      return shapeElementTypeKey as ElementTypes;
    }

    return (ElementTypes as Record<string, ElementTypes>)[shapeElementTypeKey as string];
  }

  public static isVisualShape(shape: IShape | undefined | null): boolean {
    if (!shape) {
      return false;
    }

    const seatType = this.resolve(shape.shapeSeatType);
    return !seatType || seatType === ShapeSeatTypes.NONE;
  }

  public static isBookableShape(shape: IShape | undefined | null): boolean {
    return !!shape && !this.isVisualShape(shape);
  }

  public static isAutoSelectableShape(shape: IShape | undefined | null): boolean {
    const seatType = this.resolve(shape?.shapeSeatType);

    return seatType === ShapeSeatTypes.NORMAL_CHAIR
      || seatType === ShapeSeatTypes.SEAT_WITH_FOOTSTOOL
      || seatType === ShapeSeatTypes.SEAT;
  }

  public static resolveSeatShape(seat: ISeat, shapes: readonly IShape[]): IShape | undefined {
    return shapes.find(shape => shape.id === seat.element?.shapeId) ?? seat.element?.shape;
  }
}
